/**
 * From a placed piece back to the rate an operator wrote.
 *
 * ---------------------------------------------------------------------------
 * WHY A PIECE ID IS NOT A RATE ID
 * ---------------------------------------------------------------------------
 *
 * A quote line names the PIECE that priced those nights, and a piece is a
 * placement rather than a rule. One authored rate becomes several pieces, by
 * two mechanisms that decorate the id differently:
 *
 *   `laagseizoen-lang-c#5`      an EXTENDABLE rate, placed for its fifth
 *                               repetition. The suffix comes from the legacy
 *                               expansion this engine ports, and every card
 *                               lifted from the 2026 season produces them.
 *
 *   `week__2026-04-01`          a nightly band that `flattenNightly` cut at a
 *                               narrower layer's edge. The suffix is the new
 *                               window's start, so an unchanged band keeps its
 *                               identity and a diff does not report churn.
 *
 * Both may appear, and the order matters: `#` is appended after the window
 * split, so stripping `__` first and stopping would leave `#5` behind.
 *
 * ---------------------------------------------------------------------------
 * WHY THIS IS ONE FUNCTION AND NOT THREE
 * ---------------------------------------------------------------------------
 *
 * It was three, and they disagreed. `reachable.ts` stripped only `__`, so its
 * fast path — "was this rate actually chosen by some stay?" — never matched an
 * extendable rate on a ported card, and the check silently fell through to a
 * price comparison that happened to reach the same verdict by different means.
 * A calendar component had the complete reduction and the knowledge of the id
 * format lived in a UI file; a differential test had a third copy.
 *
 * The format is minted here, in `packages/tariff`. Reading it belongs here too.
 */

/** The authored rate behind a placed piece. */
export function rateIdOf(pieceId: string): string {
  return pieceId.split('#')[0]!.split('__')[0]!;
}
